// /* @flow */

import React, { PureComponent } from "react";
import { View, Text, ScrollView, Pressable, Linking } from "react-native";

//Modules

//Components
import Tabs from "../../components/general/tabs.js";

// import Scores from "../../screens/matches/scores.js";
import Scores from './UTRScores.js'
import MatchOverlay from "../../components/general/matchoverlaycard.js";

//Helpers
import MainStyles from "../../helpers/mainstyles.js";
import Functions from "../../helpers/functions.js";
import GLOBAL from "../../helpers/global.js";
import { Image } from "react-native-web";

var accent = "#007BB2";
var accent_1 = "#36B9F2";
var color = "#121212";

export default class MyComponent extends PureComponent {
  //Setup
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      activeView: "Live",
      offset: 0,
      style: {},
    };
  }

  async componentDidMount() {
    GLOBAL.external_host = this.props.theme;

    var hideVideos = false;
    var host = "";

    var style = {};

    GLOBAL.style.active_tab = 'black'
    GLOBAL.fonts.regular = 'Montserrat'
    GLOBAL.fonts.bold = 'Montserrat'
    GLOBAL.fonts.black = 'Montserrat'
    GLOBAL.fonts.semibold = 'Montserrat'
    GLOBAL.fonts.medium = 'Montserrat'
    GLOBAL.hideBranding = true

    host = "UTR Testing";
    accent = "#000";
    accent_1 = "#000";
    color = "#fff";
    this.setState({ tour: "utr", hide_dropdown: true });

    var has_style = false;

    try {
      var route_style = this.props.style || "";
      if (route_style) {
        has_style = true;
        route_style = route_style.split("-").join('"');
        const style_obj = JSON.parse(route_style);
        if (style_obj["accent"]) {
          accent = style_obj["accent"];
        }
        if (style_obj["accent_1"]) {
          accent_1 = style_obj["accent_1"];
        }
        if (style_obj["color"]) {
          color = style_obj["color"];
        }
      }
    } catch (e) {
      console.log(e);
    }

    if (this.props.style) {
      accent_1 = this.props.style.accent_1 || accent_1;
      accent = this.props.style.accent || accent;
      color = this.props.style.color || color;
    }

    if (this.props.theme || has_style) {
      //Set theme
      GLOBAL.darkMode = false;
      GLOBAL.style = GLOBAL.style_light;
      GLOBAL.externalMode = true;
      GLOBAL.style.color_accent_1 = accent_1;
      GLOBAL.color_accent_1 = accent_1;
      GLOBAL.style.active_tab = accent;
    }

    await this.setState({
      loading: false,
      hideVideos,
      style,
      host,
      accent_1,
      accent,
      color,
    });

    if (GLOBAL.hideNavbar) {
      GLOBAL.hideNavbar();
    }
  }

  async componentDidUpdate(prevProps) {}

  async componentWillUnmount() {}

  changeTab = (activeView) => {
    this.setState({ activeView });
  };

  changeTabIndex = (activeIndex) => {
    this.setState({ activeIndex });
  };

  viewOverlayMatch = () => {
    Functions.openURL("https://tnnslive.com/match/" + this.state.overlay);
  };

  overlay = async (data) => {
    window.open(
      "https://tnnslive.com/match/" + data.docId,
      "hello",
      "width=375,height=800"
    );
  };

  hide_overlay = () => {
    this.setState({ overlay: null });
  };

  renderOverlay = () => {
    var { overlay, offset } = this.state;
    if (overlay) {
      return (
        <Pressable
          onPress={this.hide_overlay}
          style={[
            {
              width: "100%",
              height: "100%",
              position: "absolute",
              paddingHorizontal: GLOBAL.padding * 2,
              backgroundColor: "rgba(0,0,0,0.85)",
            },
            MainStyles.flexCenter,
          ]}
        >
          <View
            style={[
              { width: "100%", position: "absolute", top: offset },
              MainStyles.flexCenter,
            ]}
          >
            <MatchOverlay
              id={overlay}
              showBranding
              hide_overlay={this.hide_overlay}
            />
          </View>
        </Pressable>
      );
    } else {
      return null;
    }
  };

  handleScroll = () => {
    console.log("Scrollllll");
  };

  renderHeader = () => {
    return null
    return(
      <View style={{width:'100%', flexDirection:'row', justifyContent:'flex-start', alignItems:'center', paddingHorizontal:16, paddingVertical:12}}>
        <Image
        style={{height:48, aspectRatio:4, resizeMode:'contain'}}
        source={require('../../assets/images/utr-logo.png')}
        />
      </View>
    )
  }

  renderMain = () => {
    var { activeView } = this.state;

    var tabs = [
      { title: "Live" },
      { title: "Latest Results" },
      { title: "Up Next" },
    ];

    var render = (
      <Scores
        accent_1={this.state.accent_1}
        accent={this.state.accent}
        color={this.state.color}
        hideVideos={this.state.hideVideos}
        theme={this.props.theme}
        onPressMatch={this.overlay}
        countries={this.state.countries}
        default_tour={this.state.default_tour}
        tour={this.state.tour}
        hide_dropdown={this.state.hide_dropdown}
      />
    );

    var height = 64;

    return (
      <View
        contentContainerStyle={[
          { width: "100%" },
          MainStyles.flexStartCenter,
        ]}
        style={{
          flex: 1,
          width: "100%",
          borderColor: GLOBAL.style.borderColor,
          borderWidth: 1,
          borderTopWidth:0,
          backgroundColor: "white",
        }}
      >
        <View style={[MainStyles.flexCenter, { width: "100%" }]}>
          {this.renderHeader()}
          <Tabs
            data={tabs}
            onTapTitle={this.changeTab}
            onTapIndex={this.changeTabIndex}
            forceIndex={this.state.forceIndex}
          />
        </View>
        {render}
        {this.renderOverlay()}
      </View>
    );
  };

  renderTriangle = (height, backgroundColor, flip) => {
    return (
      <View
        style={{
          zIndex: 1,
          marginLeft: -height / 2,
          marginRight: -height / 2,
          transform: [{ scaleY: flip ? 1 : -1 }],
          width: 0,
          height: 0,
          backgroundColor: "transparent",
          borderStyle: "solid",
          borderLeftWidth: height / 2,
          borderRightWidth: height / 2,
          borderBottomWidth: height,
          borderLeftColor: "transparent",
          borderRightColor: "transparent",
          borderBottomColor: backgroundColor,
        }}
      />
    );
  };

  renderScroll = () => {
    return (
      <ScrollView
        style={{ width: "100%", flex: 1 }}
        contentContainerStyle={{ width: "100%" }}
      >
        {this.renderMain()}
      </ScrollView>
    );
  };

  render = () => {
    var { loading } = this.state;
    return loading
      ? null
      : this.state.scroll
      ? this.renderScroll()
      : this.renderMain();
  };
}
